export default __webpack_public_path__ + "static/media/demo-poster.23843f89.jpg";